import { Grid } from '@mui/material';
import { memo } from 'react';
import { AccordionCancelMarriage } from 'mutation/view-models/cancel-marriage';
import { FormikErrors, FormikTouched } from 'formik';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import PmiDivider from 'shell/components/shared/divider';
import DocumentActForm from 'shell/components/shared/act';

interface CancelActProps {
  values?: AccordionCancelMarriage;
  onChange: (
    key: keyof AccordionCancelMarriage,
    value: AccordionCancelMarriage[keyof AccordionCancelMarriage]
  ) => void;
  onChangeValues: (values: AccordionCancelMarriage) => void;
  errors?: FormikErrors<AccordionCancelMarriage>;
  touched?: FormikTouched<AccordionCancelMarriage>;
}

const CancelActComponent = ({
  values,
  onChange,
  touched,
  errors,
  onChangeValues,
}: CancelActProps): React.ReactElement => {
  return (
    <Grid container spacing={2} item>
      <Grid item xs={12}>
        <PmiDivider />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Estremi atto</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <DocumentActForm
          values={values}
          onChange={(key, value) => {
            onChange(key, value);
          }}
          onChanges={(fields) => {
            onChangeValues(fields);
          }}
          errors={errors}
          touched={touched}
        />
      </Grid>
    </Grid>
  );
};

CancelActComponent.displayName = 'CancelAct - Cancel marriage accordion component';

const CancelAct = memo(CancelActComponent);

export default CancelAct;
